import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Search',
  },
  searchResults: {
    showMore: 'Show more results',
    noResults: 'Sorry, we couldn’t find any results for your search <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC™/PEFC™',
      ecofriendly: 'Eco',
      overnight: 'Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Online design',
    },
    taglines: {
      home: 'Mehr erfahren',
      text: 'Mehr erfahren',
      themes: 'Mehr erfahren',
      external: 'Mehr erfahren',
      info: 'Mehr erfahren',
      category: 'Mehr erfahren',
      content: 'Mehr erfahren',
      product: 'Jetzt konfigurieren',
    },
    headings: {
      categories: 'Product categories',
      products: 'Products',
      external: 'Other',
    },
    slider: {
      previousSlide: 'Show previous content',
      nextSlide: 'Show next content',
    },
  },
  searchInput: {
    inputTooShortError: 'Your search term is too short (min 2)',
    results: 'Results',
    result: 'Result',
    youSearchFor: 'You searched for',
    suggestedTerm: {
      didYouMean: 'Did you mean',
      resultsFor: 'Click here for all',
      didYouMeanPostFix: '?',
      resultsForPostFix: 'results',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'List View',
      gridButtonTooltip: 'Grid View',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Clear all filters',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Filters',
        buttonsTooltipLabel: 'View',
        resultLabel: 'Search results ',
      },
      contexts:
        {
          product: 'Product',
          content: 'Miscellanoeus',
          all: 'all',
          category: 'Product categories',
          external: 'Other',
        },
    },
    breadcrumbs: {
      start: 'Start',
      search: 'Search',
    },
  },
  sideBar: {
    filter: 'Filter',
    filterOverwrite: {
      category: {
        text: 'Category',
      },
      rootCategory: {
        text: 'Category',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'Logo FSC',
          logoPfsc: 'Logo PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day Delivery',
          expressAvailable: 'Express Delivery',
          overnightAvailable: 'Next Day Delivery',
          ecoFriendly: 'Environmentally friendly materials',
          onlineDesign: 'Online design',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Your session has expired and you need to log in again. You will be forwarded to the login immediately.',
      server403: 'The request has not been applied because it lacks valid authentication credentials. Please reload the page or contact our customer service.',
      default: 'There was an error on the server. Please reload the page or contact our customer service.',
    },
    errors: {
      server400: 'The request was malformed. Please reload the page or contact our customer service.',
      server404: '404 Page not found. Please go to previous page or contact our customer service.',
      server500: 'There was an error on the server. Please reload the page or contact our customer service.',
      server501: 'There was an error on the server. Please reload the page or contact our customer service.',
      server502: 'There was an error on the server and you get a invalid response. Please reload the page or contact our customer service.',
      server503: 'There was an error on the server. Please reload the page or contact our customer service.',
      server504: 'There was an error on the server. Please reload the page or contact our customer service.',
      default: 'The server has a problem with the request. Please reload the page or contact our customer service.',
    },
  },
};
export default translation;
